import React from "react";
import { StaticQuery, graphql } from "gatsby";

import { AppContextProvider } from "../../context";
import { useAppInitialization } from "../../hooks";

import SEO from "../../components/elements/SEO";
import Header from "../Header";
import Footer from "../Footer";

import CONSTANTS from "../../utils/constants";

import "../../styles/global.css";
import "./style.css";

const Layout = ({ children }) => {
  useAppInitialization();

  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
            }
          }
        }
      `}
      render={(data) => (
        <div className="flex flex-column flex-justify-space-between min-height-100vh">
          <link
            href="https://fonts.googleapis.com/css?family=Lora:400,400i,700,700i"
            rel="stylesheet"
          />
          <div className="App blog-body">
            <SEO siteMetadata={data.site.siteMetadata} />

            <Header reference={CONSTANTS.PAGE_REFERENCES.BLOG} />

            <div>{children}</div>
          </div>

          <Footer />
        </div>
      )}
    />
  );
};

export default ({ children, ...props }) => {
  return (
    <AppContextProvider>
      <Layout {...props}>{children}</Layout>
    </AppContextProvider>
  );
};
